module.exports = __webpack_public_path__ + "media/SelectSceneSlideUp.80086948.mp3";